import { useEffect } from 'react';

export const SITE_URL = 'https://juzamma.nl';

export function usePageMeta({ title, description, path = '/', robots = 'index, follow' }) {
  useEffect(() => {
    document.title = title;
    const values = {
      'meta[name="description"]': description,
      'meta[name="robots"]': robots,
      'meta[property="og:title"]': title,
      'meta[property="og:description"]': description,
      'meta[property="og:url"]': `${SITE_URL}${path}`,
      'meta[name="twitter:title"]': title,
      'meta[name="twitter:description"]': description,
    };
    for (const [selector, value] of Object.entries(values)) {
      document.querySelector(selector)?.setAttribute('content', value);
    }
    document.querySelector('link[rel="canonical"]')?.setAttribute('href', `${SITE_URL}${path}`);
  }, [description, path, robots, title]);
}

export function metaForPath(pathname, surahs) {
  if (pathname === '/') {
    return {
      title: "Juz 'Amma leren — Arabisch, Nederlands & audio | juzamma.nl",
      description: "Leer de 37 soera's van Juz 'Amma lezen en begrijpen met Nederlandse vertaling, transliteratie, audio en quizzen.",
      path: '/',
      type: 'home',
    };
  }
  if (pathname === '/quiz') {
    return {
      title: "Juz 'Amma quiz — Test je kennis | juzamma.nl",
      description: "Oefen de volgorde, betekenis en herkenning van verzen uit alle 37 soera's van Juz 'Amma.",
      path: '/quiz',
      type: 'quiz',
    };
  }
  const routePart = pathname.match(/^\/soera\/(.+?)\/?$/)?.[1];
  const surah = surahs.find((item) => `${item.number}-${item.slug}` === routePart);
  if (surah) {
    return {
      title: `Soera ${surah.latinName} (${surah.number}) leren — Arabisch, Nederlands & audio`,
      description: `Lees en leer soera ${surah.latinName} (${surah.number}), ${surah.meaning}: ${surah.verseCount} verzen met Uthmani-Arabisch, Nederlandse vertaling, transliteratie en audio.`,
      path: surah.path,
      type: 'surah',
      surah,
    };
  }
  return {
    title: "Pagina niet gevonden | Juz 'Amma",
    description: "Deze pagina bestaat niet. Ga terug naar het overzicht van de 37 soera's van Juz 'Amma.",
    path: pathname,
    type: 'not-found',
    robots: 'noindex, follow',
  };
}
